import React from 'react';
import { Helmet } from 'react-helmet-async';
import MainLayout from '../layouts/MainLayout';
import { CheckCircleOutlined, SafetyOutlined, TrophyOutlined, TeamOutlined } from '@ant-design/icons';

const About = () => {
    const features = [
        {
            icon: <CheckCircleOutlined className="text-4xl text-orange-600" />,
            title: 'Kaliteli Ürünler',
            description: 'Dünya çapında tanınmış lastik markalarının yetkili distribütörüyüz. Orijinal ve garantili ürünler sunuyoruz.'
        },
        {
            icon: <SafetyOutlined className="text-4xl text-orange-600" />,
            title: 'Güvenli Hizmet',
            description: 'Uzman ekibimiz ve modern ekipmanlarımızla güvenli lastik montaj ve balans hizmeti veriyoruz.'
        },
        {
            icon: <TrophyOutlined className="text-4xl text-orange-600" />,
            title: '25+ Yıllık Tecrübe',
            description: 'Sektörde 25 yılı aşkın tecrübemizle müşterilerimize en iyi hizmeti sunuyoruz.'
        },
        {
            icon: <TeamOutlined className="text-4xl text-orange-600" />,
            title: 'Profesyonel Ekip',
            description: 'Alanında uzman, sertifikalı ve deneyimli ekibimizle yanınızdayız.'
        }
    ];

    return (
        <MainLayout>
            <Helmet>
                <title>Hakkımızda - Sakarya Lastik | 25+ Yıllık Tecrübe</title>
                <meta name="description" content="Sakarya Lastik olarak 25 yılı aşkın tecrübemizle kaliteli lastik satışı ve montaj hizmeti sunuyoruz. Güvenilir, hızlı ve profesyonel hizmet." />
                <meta name="keywords" content="sakarya lastik, hakkımızda, lastik satışı, lastik montaj, otomotiv" />
            </Helmet>

            {/* Hero Section */}
            <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">Hakkımızda</h1>
                    <p className="text-xl text-orange-100 max-w-2xl">
                        Sakarya'nın en güvenilir lastik merkezi olarak 25 yılı aşkın tecrübemizle hizmetinizdeyiz
                    </p>
                </div>
            </div>

            {/* About Content */}
            <div className="container mx-auto px-4 py-12">
                <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800 mb-6">
                            Sakarya Lastik - Güvenin Adresi
                        </h2>
                        <div className="space-y-4 text-gray-700 leading-relaxed">
                            <p>
                                <strong className="text-orange-600">Sakarya Lastik</strong> olarak 1998 yılından bu yana Sakarya ve çevre illerde
                                kaliteli lastik satışı ve profesyonel montaj hizmeti sunuyoruz. 25 yılı aşkın tecrübemizle
                                sektörde öncü firmalardan biri haline geldik.
                            </p>
                            <p>
                                Michelin, Bridgestone, Continental, Pirelli, Goodyear, Lassa gibi dünya çapında tanınmış
                                lastik markalarının yetkili satış noktasıyız. Geniş ürün yelpazemizle binek otomobil,
                                SUV, ticari araç ve kamyon lastiklerinde her ihtiyaca uygun çözümler sunuyoruz.
                            </p>
                            <p>
                                Modern tesisimizde bulunan son teknoloji ekipmanlarımız ve uzman ekibimizle lastik montaj,
                                balans ayarı, rot ayarı, lastik tamiri gibi hizmetleri en üst düzeyde gerçekleştiriyoruz.
                            </p>
                            <p>
                                Müşteri memnuniyetini her şeyin üstünde tutan anlayışımızla, her zaman adil fiyat,
                                hızlı servis ve kaliteli hizmet garantisi veriyoruz.
                            </p>
                        </div>
                    </div>
                    <div>
                        <img
                            src="/images/araba-lastik-bg.webp"
                            alt="Sakarya Lastik Mağaza"
                            className="rounded-lg shadow-2xl w-full h-auto"
                        />
                    </div>
                </div>

                {/* Features Grid */}
                <div className="mb-16">
                    <h2 className="text-3xl font-bold text-gray-800 text-center mb-12">
                        Neden Sakarya Lastik?
                    </h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {features.map((feature, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center">
                                <div className="flex justify-center mb-4">
                                    {feature.icon}
                                </div>
                                <h3 className="text-xl font-bold text-gray-800 mb-3">
                                    {feature.title}
                                </h3>
                                <p className="text-gray-600">
                                    {feature.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mission & Vision */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    <div className="bg-orange-50 p-8 rounded-lg">
                        <h3 className="text-2xl font-bold text-orange-700 mb-4">Misyonumuz</h3>
                        <p className="text-gray-700 leading-relaxed">
                            Müşterilerimize en kaliteli lastikleri en uygun fiyatlarla sunmak, güvenli sürüş için
                            profesyonel hizmet vermek ve otomotiv sektöründe güvenilir bir iş ortağı olmak.
                        </p>
                    </div>
                    <div className="bg-orange-50 p-8 rounded-lg">
                        <h3 className="text-2xl font-bold text-orange-700 mb-4">Vizyonumuz</h3>
                        <p className="text-gray-700 leading-relaxed">
                            Türkiye'nin en büyük lastik zincirlerinden biri olmak, dijital dönüşümle müşteri
                            deneyimini iyileştirmek ve sürdürülebilir, çevre dostu lastik çözümleri sunmak.
                        </p>
                    </div>
                </div>

                {/* Values */}
                <div className="bg-gray-50 p-8 rounded-lg">
                    <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Değerlerimiz</h3>
                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="text-center">
                            <div className="text-orange-600 text-5xl mb-3">🤝</div>
                            <h4 className="font-bold text-gray-800 mb-2">Güven</h4>
                            <p className="text-gray-600 text-sm">Şeffaf, dürüst ve güvenilir hizmet</p>
                        </div>
                        <div className="text-center">
                            <div className="text-orange-600 text-5xl mb-3">⭐</div>
                            <h4 className="font-bold text-gray-800 mb-2">Kalite</h4>
                            <p className="text-gray-600 text-sm">Her zaman orijinal ve garantili ürünler</p>
                        </div>
                        <div className="text-center">
                            <div className="text-orange-600 text-5xl mb-3">💼</div>
                            <h4 className="font-bold text-gray-800 mb-2">Profesyonellik</h4>
                            <p className="text-gray-600 text-sm">Uzman kadro ve modern ekipman</p>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default About;
